import { makeStyles } from "tss-react/mui";
import { MiAlert, MiBox, MiSectionHeader } from "@miplatform/components";
import { BUTTON_VARIANTS, ICONS_WEB } from "@miplatform/constants";
import { pluralize } from "@miplatform/utils";
import * as mdi from "@mdi/js";
import { Box } from "@mui/material";
import { EmptySearchResults } from "../../views/Estimating/components/EmptySearchResults/EmptySearchResults";

/**
 * @param {Object} props
 * @param {boolean} [props.open]
 * @param {string} [props.title]
 * @param {function} [props.onClose]
 * @param {string} [props.alertTitle]
 * @param {string} [props.alertDescription]
 * @param {string} [props.storageKey]
 * @param {boolean} [props.isLoading]
 * @param {Array} [props.results]
 * @param {string} [props.noResultsHelperText]
 * @param {boolean} [props.hasFilters]
 * @param {function} [props.handleResetFilterSelection]
 * @param {function} [props.renderResults]
 * @param {number} [props.flex]
 */

export function SearchResultsContainer({
  open = false,
  title = "Search Results",
  onClose,
  alertTitle = "",
  alertDescription = "",
  storageKey,
  isLoading = false,
  results = [],
  noResultsHelperText = "Please adjust your search or filter criteria and try again.",
  hasFilters = false,
  handleResetFilterSelection = () => null,
  renderResults = () => null,
  flex,
}) {
  const { classes } = useStyles({ flex });

  if (!open) {
    return null;
  }

  const renderEmptyResults = () => (
    <EmptySearchResults
      helperText={noResultsHelperText}
      actions={
        hasFilters && !isLoading
          ? [
              {
                title: "Reset Filters",
                onClick: handleResetFilterSelection,
                variant: BUTTON_VARIANTS.OUTLINED,
              },
            ]
          : []
      }
    />
  );

  return (
    <MiBox className={classes.container} height="auto">
      <MiSectionHeader
        title={title}
        subtitle={pluralize(results.length, "Item")}
        rightIcon={onClose && mdi[ICONS_WEB.CLOSE]}
        onRightIconClick={onClose}
      />
      <MiAlert
        title={alertTitle}
        description={alertDescription}
        storageKey={storageKey}
      />
      <Box className={classes.overflowContainer}>
        {results.length === 0 && !isLoading
          ? renderEmptyResults()
          : renderResults()}
      </Box>
    </MiBox>
  );
}

const useStyles = makeStyles()((theme, { flex = 1 }) => ({
  container: {
    width: "100%",
    flex,
    display: "flex",
    flexDirection: "column",
    borderRadius: theme.spacing(0),
    margin: theme.spacing(0),
  },
  overflowContainer: {
    overflow: "auto",
    flex: 1,
  },
}));
